import { render, staticRenderFns } from "./NoteThreadOverview.vue?vue&type=template&id=85c7c782&"
import script from "./NoteThreadOverview.vue?vue&type=script&lang=ts&"
export * from "./NoteThreadOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports